const PROJECT_SCHEMA = {
  projectId: 'ID',
  displayId: 'String',
  title: 'String',
  status: 'String',
  scheduledStartDate: 'String',
  dueDate: 'String',
  overdue: 'Boolean',
  actualStartDate: 'String',
  actualEndDate: 'String',
  client: 'ClientInput',
  site: 'SiteInput',
  owner: 'UserInput',
  members: '[UserInput]',
  addMembers: '[UserInput]',
  deleteMembers: '[UserInput]',
  milestones: '[MilestoneInput]',
  totalTasks: 'Int',
  plannedTasks: 'Int',
  inProgressTasks: 'Int',
  blockedTasks: 'Int',
  completedTasks: 'Int',
  overdueTasks: 'Int',
  totalMilestones: 'Int',
  completedMilestones: 'Int',
  loggedInUserRole: 'RoleInput'
};

const PROJECT_VIEW_IDS = {
  trash: '19'
};

const STATUS_MAP = {
  'In Progress': 'info',
  Planned: 'info',
  Cancelled: 'secondary',
  Blocked: 'secondary',
  Deleted: 'secondary',
  Completed: 'success'
};

export { PROJECT_SCHEMA, PROJECT_VIEW_IDS, STATUS_MAP };
